import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetProcedureV3Response,
	GetProcedureMedicalGuideV3,
	GetProcedureV3Request,
} from 'domain/usecases/private/guide-flow/medical-guide/get-procedure-v3';

export class RemoteGetProcedureMedicalGuideV3 implements GetProcedureMedicalGuideV3 {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetProcedureV3Response>,
	) {}

	async get({
		signal,
		...params
	}: GetProcedureV3Request): Promise<GetProcedureV3Response> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
